import { Injectable } from '@angular/core';
import { ECurrency } from '../shared/enums/campaign.enum';

@Injectable({
  providedIn: 'root',
})
export class CurrencyUtilitiesService {
  public static getCurrencyIcon(currency: ECurrency): string {
    switch (currency) {
      case ECurrency.eur:
        return 'icons/currency-euro.svg';
      case ECurrency.usd:
        return 'icons/currency-dollar.svg';
    }
  }

  public static getCurrencySymbol(currency: ECurrency): string {
    switch (currency) {
      case ECurrency.eur:
        return '€';
      case ECurrency.usd:
        return '$';
    }
  }
}
